import { render, staticRenderFns } from "./ExtendedLabelsTable.vue?vue&type=template&id=01c929f6&scoped=true"
import script from "./ExtendedLabelsTable.vue?vue&type=script&lang=js"
export * from "./ExtendedLabelsTable.vue?vue&type=script&lang=js"
import style0 from "./ExtendedLabelsTable.vue?vue&type=style&index=0&id=01c929f6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c929f6",
  null
  
)

export default component.exports